import { useEffect } from 'react';
import Team from "../components/team";
import { currentAuthenticatedUser } from '../services/userHandler';
import Chatbot from "../components/chatbot"

function App() {
    useEffect(() => {
      currentAuthenticatedUser();
    }, []);
  
    return (
      <div>
        {/* <Team /> */}
        {/* <Chatbot /> */}
      </div>
    );
  }
  
  export default App;